import { Box, Grow, styled } from '@mui/material'
import {
  Message,
  RawImageMessage,
  RawWappMessage,
} from '@weblite/ts-action/message'
import { getWappIcon } from '$logic/wapps/wapps.helper'

const ThumbnailContainer = styled('div')`
  display: flex;
  border-radius: 2px;
  overflow: hidden;
`

const Thumbnail = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

function ImageThumbnail({ src }: { src: string }) {
  return <Thumbnail src={src} alt="image-message-thumbnail" />
}

function WappThumbnail({ wappId }: { wappId?: string }) {
  return (
    <Box
      sx={{
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '8px',
      }}
    >
      <Thumbnail src={getWappIcon(wappId)} alt="wapp-message-thumbnail" />
    </Box>
  )
}

export function MessagePreviewThumbnail({
  message,
  height,
}: {
  message: Message
  height?: number
}) {
  if (!message || (message.type !== 'IMAGE' && message.type !== 'WAPP'))
    return null

  return (
    <Grow in timeout={100}>
      <ThumbnailContainer
        sx={{
          width: `${height}px`,
          minWidth: `${height}px`,
          height: `${height}px`,
          backgroundColor: 'white',
        }}
      >
        {message.type === 'IMAGE' ? (
          <ImageThumbnail
            src={(message as RawImageMessage).attachment.base64}
          />
        ) : (
          <WappThumbnail
            wappId={(message as RawWappMessage).attachment?.wappId}
          />
          //     NOTE : WHY WAPP MESSAGE MIGHT NOT HAVE ATTACHMENT. HAH ?
        )}
      </ThumbnailContainer>
    </Grow>
  )
}
MessagePreviewThumbnail.defaultProps = {
  height: 40,
}
